export enum HoursPerWeek {
    Hours20 = 1,
    Hours25 = 2,
    Hours30 = 3,
    Hours35 = 4,
}
